import React from 'react';
import { motion } from 'framer-motion';
import { SparklesIcon } from 'lucide-react';
export function EmotionalTransition() {
  return <section className="py-24 bg-gradient-to-b from-[#FFF8F0] to-[#F5EDE3] text-[#3D2B1F] px-4 relative overflow-hidden" data-id="element-32">
      {/* Decorative background elements */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-[#C67B30]/5 rounded-full blur-[120px] pointer-events-none" data-id="element-33"></div>

      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-34">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} data-id="element-35">
          <div className="inline-flex items-center justify-center p-3 bg-[#C67B30]/10 rounded-2xl mb-8 border border-[#C67B30]/20" data-id="element-36">
            <SparklesIcon className="w-8 h-8 text-[#C67B30]" data-id="element-37" />
          </div>

          <h2 className="text-4xl md:text-5xl font-black mb-8 leading-tight text-transparent bg-clip-text bg-gradient-to-r from-[#3D2B1F] to-[#6B5344]" data-id="element-38">
            Muchas veces el secreto no está en el budín.
          </h2>

          <p className="text-2xl md:text-3xl font-bold text-[#C67B30] mb-8 leading-relaxed" data-id="element-39">
            Está en la cobertura, el glaseado o el toque final.
          </p>

          <p className="text-xl md:text-2xl text-[#6B5344] font-medium max-w-3xl mx-auto" data-id="element-40">
            Ese detalle que transforma un budín simple en un postre
            espectacular.
          </p>
        </motion.div>
      </div>
    </section>;
}